import {Expose} from "class-transformer";
import ModelTransferContact from "@models/v2/transfer/ModelTransferContact";

export class TransferPaymentServiceClient {
	@Expose({name: 'id'})
	private _id: number | null = null;

	@Expose({name: 'login'})
	private _login: string | null = null;

	@Expose({name: 'shortName'})
	private _shortName: string | null = null;

	@Expose({ name: 'contact' })
	private _contact: ModelTransferContact | null = null;

	get id() {
		return this._id;
	}

	get login() {
		return this._login;
	}

	get shortName() {
		return this._shortName;
	}

	get contact() {
		return this._contact;
	}
}
